import React, { useState } from 'react';
import { Form } from 'react-bootstrap-5';
import PropTypes from 'prop-types';

import BrokersList from './brokers_list';
import ErrorAlert from './error_alert';
import Button from 'shared/button';

export default function SuggestedListingForm({
  backButtonClicked,
  brokers,
  errorMessages,
  fullAddress,
  hasErrors,
  maxBrokersLimit,
  saving,
  showBrokerSelect,
  suggestedAddresses,
  suggestedPropertyListing,
  userEnteredFields,
  onBrokerChange
}) {
  const startingAddressId = suggestedAddresses.length > 0 ? suggestedAddresses[0].id : -1;
  const [selectedOption, setSelectedOption] = useState(startingAddressId);

  const onFormSubmit = (e) => {
    e.preventDefault();

    let params = {};
    if (selectedOption != -1) {
      params = {
        insightsId: suggestedAddresses.find(suggestedAddress => suggestedAddress.id === selectedOption).id
      };
    } else if (selectedOption === -1) {
      params = { researchPropertyParams: userEnteredFields };
    }

    suggestedPropertyListing(params);
  };

  return (
    <Form onSubmit={onFormSubmit}>
      <h3 className="mb-5 mt-0 text-center" style={{ fontWeight: 'bold' }}>Address Correction</h3>

      <ErrorAlert errorMessages={errorMessages} hasErrors={hasErrors}/>

      <div className="mb-4">
        <h4>Address Entered</h4>
        <Form.Label className="d-flex border p-4 address-correction">
          <Form.Check
            checked={selectedOption === -1}
            className="mr-4"
            name="address-correction"
            type="radio"
            value="user-entered"
            onChange={() => setSelectedOption(-1)}
          />
          {fullAddress}
        </Form.Label>
      </div>

      <div className="mb-5">
        <h4>Suggested Addresses</h4>
        {suggestedAddresses.map(suggestedAddress => (
          <Form.Label className="d-flex border p-4 address-correction" key={suggestedAddress.id}>
            <Form.Check
              checked={selectedOption === suggestedAddress.id}
              className="mr-4"
              name="address-correction"
              type="radio"
              value={suggestedAddress.id}
              onChange={() => setSelectedOption(suggestedAddress.id)}
            />
            {suggestedAddress.fullAddress}
          </Form.Label>
        ))}
      </div>

      {showBrokerSelect &&
        <BrokersList
          brokers={brokers}
          maxBrokersLimit={maxBrokersLimit}
          onSetBrokers={brokers => onBrokerChange(brokers)}
        />}

      <div className="mt-5 d-flex justify-content-end">
        <Button.Accent
          className="mr-3"
          name="back-button"
          outlined
          type="button"
          onClick={backButtonClicked}
        >
          Back
        </Button.Accent>
        <Button.Primary
          disabled={saving}
          type="submit"
        >
          {saving ? 'Creating Listing...' : 'Create Listing'}
        </Button.Primary>
      </div>
    </Form>
  );
}

SuggestedListingForm.propTypes = {
  backButtonClicked: PropTypes.func.isRequired,
  brokers: PropTypes.array.isRequired,
  errorMessages: PropTypes.object.isRequired,
  fullAddress: PropTypes.string.isRequired,
  hasErrors: PropTypes.bool.isRequired,
  maxBrokersLimit: PropTypes.number.isRequired,
  saving: PropTypes.bool.isRequired,
  showBrokerSelect: PropTypes.bool.isRequired,
  suggestedAddresses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      fullAddress: PropTypes.string.isRequired
    }).isRequired
  ).isRequired,
  suggestedPropertyListing: PropTypes.func.isRequired,
  userEnteredFields: PropTypes.object.isRequired,
  onBrokerChange: PropTypes.func.isRequired,
};
